import { createAsyncThunk } from '@reduxjs/toolkit';
import InfluencerFactService from '../../../api/services/InfluencerFactService';

export const fetchInfluencerFacts = createAsyncThunk(
  'influencerFact/fetchInfluencerFacts',
  async ({ page, search }) => {
    return await InfluencerFactService.fetchInfluencerFacts(page, search);
  },
);

export const fetchAgencyInfluencerFacts = createAsyncThunk(
  'influencerFact/fetchAgencyInfluencerFacts',
  async ({ page, search, influencerId }) => {
    return await InfluencerFactService.fetchAgencyInfluencerFacts(page, search, influencerId);
  },
);

export const createInfluencerFacts = createAsyncThunk('influencerFact/createInfluencerFacts', async ({ facts }) => {
  return await InfluencerFactService.createInfluencerFacts(facts);
});

export const agencyCreateInfluencerFacts = createAsyncThunk(
  'influencerFact/agencyCreateInfluencerFacts',
  async ({ facts, influencerId }) => {
    return await InfluencerFactService.agencyCreateInfluencerFacts(facts, influencerId);
  },
);

export const deleteInfluencerFact = createAsyncThunk(
  'influencerFact/deleteInfluencerFact',
  async ({ influencerFactId }) => {
    return await InfluencerFactService.deleteInfluencerFact(influencerFactId);
  },
);

export const deleteAgencyInfluencerFact = createAsyncThunk(
  'influencerFact/deleteAgencyInfluencerFact',
  async ({ influencerFactId }) => {
    return await InfluencerFactService.deleteAgencyInfluencerFact(influencerFactId);
  },
);

export const editInfluencerFact = createAsyncThunk(
  'influencerFact/editInfluencerFact',
  async ({ influencerFactId, text }) => {
    return await InfluencerFactService.editInfluencerFact(influencerFactId, text);
  },
);

export const agencyEditInfluencerFact = createAsyncThunk(
  'influencerFact/agencyEditInfluencerFact',
  async ({ influencerFactId, text }) => {
    return await InfluencerFactService.agencyEditInfluencerFact(influencerFactId, text);
  },
);
